export default {
  "api": {
    "name": "api",
    "label": "API endpoint",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "",
    "type": "input",
    "required": true
  },
  "secretKey":
      {
        "name": "secretKey",
        "label": "SecretKey",
        "hint": {
          "parametr": "dateTo",
          "format": "String(50)",
          "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
        },
        "value": "",
        "type": "input",
        "required": true
      },
  "contenttype": {
    "name": "contenttype",
    "label": "Content-Type",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "url",
    "values": {
      "url": "application/x-www-form-urlencoded"
    },
    "type": "select"
  },
  "accept": {
    "name": "accept",
    "label": "Accept",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "json",
    "values": {
      "xml": "application/xml",
      "json": "application/vnd.api+json"
    },
    "type": "select"
  },
  "clientId": {
    "name": "clientId",
    "label": "clientId",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "",
    "type": "input",
    "required": true
  },
//  "sign": {
//    "name": "sign",
//    "label": "sign",
//    "hint": {
//      "parametr": "dateTo",
//      "format": "String(50)",
//      "description": "Request signature"
//    },
//    "value": "",
//    "type": "input",
//    "required": true
//  },
  "userId": {
    "name": "userId",
    "label": "userId",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "User identificator"
    },
    "value": "",
    "type": "input",
    "required": true
  },
  "sessionId": {
    "name": "sessionId",
    "label": "sessionId",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Session identificator"
    },
    "value": "",
    "type": "input"
  },
  "nick": {
    "name": "nick",
    "label": "nick",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "User nickname"
    },
    "value": "",
    "type": "input"
  },
  "password": {
    "name": "password",
    "label": "password",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "User password"
    },
    "value": "",
    "type": "input"
  },
  "authType": {
    "name": "authType",
    "label": "authType",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": " Authorization type. Possible values are external, internal, default value is external"
    },
    "value": "external",
    "values": {
      "internal": "internal",
      "external": "external"
    },
    "type": "select"
  },
  "gameCode": {
    "name": "gameCode",
    "label": "gameCode",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Possible values are 'poker', 'casinoLobby', 'casino', 'sport' default value 'poker'"
    },
    "value": "",
    "values": {
      "poker": "poker",
      "casino": "casino",
      "casinoLobby": "casinoLobby",
      "sport": "sport"
    },
    "type": "select"
  },
  "tableId": {
    "name": "tableId",
    "label": "tableId",
    "hint": {
      "parametr": "dateTo",
      "format": "Integer",
      "description": "Table identificator, is used only when gameCode = 'poker'"
    },
    "value": "",
    "type": "input"
  },
  "gameId": {
    "name": "gameId",
    "label": "gameId",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Game identificator, is used only when gameCode = 'casino' or 'sport'"
    },
    "value": "",
    "type": "input"
  },
  "lang": {
    "name": "lang",
    "label": "lang",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Language ISO code"
    },
    "value": "",
    "type": "input"
  },
  "launchOptions": {
    "name": "launchOptions",
    "label": "launchOptions",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Additional launch options for html5-application. JSON array. Is used only when gameCode = 'poker' or 'casinoLobby'"
    },
    "value": "",
    "type": "input"
  },
  "currency": {
    "name": "currency",
    "label": "currency",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Currency ISO code"
    },
    "value": "",
    "type": "input"
  },
  "bonusCode": {
    "name": "bonusCode",
    "label": "bonusCode",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "",
    "type": "input"
  },
  "email": {
    "name": "email",
    "label": "email",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "User email"
    },
    "value": "",
    "type": "input",
    "pattern": "^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$",
    "isValid": null
  },
  "phoneNumber": {
    "name": "phoneNumber",
    "label": "phoneNumber",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "User phone number"
    },
    "value": "",
    "type": "input",
    "pattern": "\\+?\\d{8,15}",
    "isValid": null
  },
  "redeemCode": {
    "name": "redeemCode",
    "label": "redeemCode",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Sign up code"
    },
    "value": "",
    "type": "input"
  },
  "active": {
    "name": "active",
    "label": "active",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": ""
    },
    "value": "",
    "values": {
      "true": "true",
      "false": "false"
    },
    "value": "",
    "type": "select"
  },
  "verified": {
    "name": "verified",
    "label": "verified",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": ""
    },
    "value": "",
    "values": {
      "true": "true",
      "false": "false"
    },
    "type": "select"
  },
  "country": {
    "name": "country",
    "label": "country",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "",
    "type": "input"
  },
  "referralCode": {
    "name": "referralCode",
    "label": "referralCode",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"
    },
    "value": "",
    "type": "input"
  },
  "tag": {
    "name": "tag",
    "label": "tag",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "User tag"
    },
    "value": "",
    "type": "input"
  },
  "avatar": {
    "name": "avatar",
    "label": "avatar",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": ""
    },
    "value": "",
    "type": "input"
  },
  "userIp": {
    "name": "userIp",
    "label": "userIp",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": "Required for gameCode = 'casino' or 'sport'"
    },
    "value": "",
    "type": "input"
  },
  "longLifeLoginToken": {
    "name": "longLifeLoginToken",
    "label": "longLifeLoginToken",
    "hint": {
      "parametr": "dateTo",
      "format": "String(50)",
      "description": ""
    },
    "value": "",
    "values": {
      "true": "true",
      "false": "false"
    },
    "type": "select"
  },
  "avatarId": {
    "name": "avatarId",
    "label": "avatarId",
    "hint": {
      "parametr": "dateTo",
      "format": "Integer",
      "description": "The id of avatar or preset"
    },
    "value": "",
    "type": "input"
  },
  "trustedLevel": {
    "name": "trustedLevel",
    "label": "trustedLevel",
    "hint": {
      "parametr": "dateTo",
      "format": "Integer",
      "description": ""
    },
    "value": "",
    "type": "input"
  },
}
